const { DataServiceEndPoint } = require("@cloudbreakus/network-utilities")

class SSE extends DataServiceEndPoint {
  static key = "SSE"

  getSubscriptionUrl = () => {
    if (this._config.get("sse.v2.useDynamicNotification")) {
      return `${this._config.get("sse.v2.dynamicNotificationUrl")}/subscriptions/v2`
    }

    if (this._config.get("sse.v2.useAlternativeNotificationUrl")) {
      return `${this.url}/v1/subscriptions/v2`
    }

    return `${this._config.get("sse.v2.notificationUrl")}/subscriptions/v2`
  }

  subscribe = (payload) => {
    return this._httpService.put(this.getSubscriptionUrl(), payload, {
      headers: { Authorization: `bearer ${this.token}` },
    })
  }

  unsubscribe = (data) => {
    return this._httpService.delete(this.getSubscriptionUrl(), {
      headers: { Authorization: `bearer ${this.token}` },
      data,
    })
  }
}

module.exports = SSE
